import { render } from "./Clever.vue?vue&type=template&id=6713dd44&scoped=true"
import script from "./Clever.vue?vue&type=script&lang=js"
export * from "./Clever.vue?vue&type=script&lang=js"

import "./Clever.vue?vue&type=style&index=0&id=6713dd44&scoped=true&lang=scss"
import "./Clever.vue?vue&type=style&index=1&id=6713dd44&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6713dd44"]])

export default __exports__